import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useSettingsFetch = () => {
  const response = useQuery({
    queryKey: ['openApiSettings'],
    queryFn: () => api.settings.fetchOpenApi(),
    enabled: false, // Запрос выполняется только по требованию
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки OpenAPI',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
